var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4439 9.61447L8.67365 14.3848C8.4888 14.5726 8.24432 14.665 7.99984 14.665C7.75536 14.665 7.51148 14.5719 7.32544 14.3855L2.55514 9.61522C2.18246 9.24254 2.18246 8.63879 2.55514 8.26612C2.92782 7.89344 3.53156 7.89344 3.90424 8.26612L7.04578 11.4093V2.26225C7.04578 1.73483 7.47302 1.33502 7.97301 1.33502C8.473 1.33502 8.9539 1.73483 8.9539 2.26225V11.4093L12.0963 8.26686C12.469 7.89418 13.0728 7.89418 13.4454 8.26686C13.8181 8.63954 13.8166 9.24179 13.4439 9.61447Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.ac512be1aeda7e88dbbf2984a95520a3.svg";
export { ForwardRef as ReactComponent };